import { useEffect, useState } from "react";
import { Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const View = ({ url, type, name, big }) => (
  type === "application/pdf"
    ? <iframe src={url} title={name} className={`w-full rounded-lg bg-white ${big ? "h-[80vh]" : "h-72"}`} />
    : <img src={url} alt={name} className={`w-full rounded-lg bg-muted object-contain ${big ? "max-h-[80vh]" : "h-72"}`} />
);

export const DocPreview = ({ doc }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let u = null;
    api.get(`/admin/documents/${doc.id}/file`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); })
      .catch(() => setErr(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [doc.id]);

  return (
    <div className="relative w-full md:w-80 shrink-0" data-testid={`admin-doc-preview-${doc.id}`}>
      {err && <div className="grid h-72 place-items-center rounded-lg bg-muted text-sm text-muted-foreground">Não foi possível carregar o arquivo</div>}
      {!err && !url && <div className="h-72 animate-pulse rounded-lg bg-muted" />}
      {url && <View url={url} type={doc.content_type} name={doc.original_filename} />}
      {url && (
        <Button size="sm" variant="secondary" className="absolute right-2 top-2" onClick={() => setOpen(true)} data-testid={`admin-doc-expand-${doc.id}`}>
          <Maximize2 className="mr-1 h-4 w-4" />Ampliar
        </Button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl" data-testid="admin-doc-preview-dialog">
          <DialogHeader><DialogTitle>{doc.original_filename}</DialogTitle><DialogDescription>Documento enviado pelo cliente {doc.user_name}.</DialogDescription></DialogHeader>
          {url && <View url={url} type={doc.content_type} name={doc.original_filename} big />}
        </DialogContent>
      </Dialog>
    </div>
  );
};
